var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zone-list',{attrs:{"getParams":_vm.getParams,"disable-create":_vm.data.provider !== 'OneCloud',"hidden-actions":['create'],"id":"ZoneListForCloudregionSidePage"}})}
var staticRenderFns = []

export { render, staticRenderFns }